export default __webpack_public_path__ + "static/imgGAP-6c0251bb8abff2d7c43103ed56cb067c.webp";